<template>
<div id="secure">

    <NewTopMenu />
    <div class="container">
        <div class="columns">
            <div class="column is-3"><button class="button is-medium is-fullwidth" v-on:click="goManageClasses()">Classes/Departments &amp; Users</button></div>
            <div class="column is-3"><button class="button is-medium is-fullwidth" v-on:click="goManageTeachers()">Teachers/Supervisors</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth" v-on:click="goManageBehaviors()">Items</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth is-primary">Notifications</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth" v-on:click="goManageGroups()">Groups</button></div>
            <!-- <div class="column is-2"><button class="button is-medium is-fullwidth" v-on:click="goManageBadges()">Badges</button></div> -->
        </div>
        
        <div class="columns">
            <div class="column is-12">
                <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">Notifications</p>
                        <a class="button is-primary" v-on:click="addContentForm()" style="margin: 5px;" v-show="!addContent">Add A Notification</a>
                        <a class="button is-warning" v-on:click="closeAddContentForm()" style="margin: 5px" v-show="addContent">Close Add Notification</a>
                    </div>
                    <div class="card-content">                
                        <div class="content" v-show="addContent">                                    
                            <add-content></add-content>
                        </div>
                        <loading :active.sync="isLoading" 
                            :can-cancel="false" 
                            :is-full-page="true">
                        </loading>
                        <template>
                            <b-tabs type="is-toggle-rounded" expanded multiline>
                                <b-tab-item label="Notifications to Teacher/Supervisor (via QR Points app)">
                                    <div><data-list v-bind:dataList="dataList" class="columns is-multiline"></data-list></div>
                                </b-tab-item>
                                <b-tab-item label="Notifications to Students/Parents/Staff (via QR Points Monitoring app)">
                                    <div><data-list-parents v-bind:dataList="dataListParents" class="columns is-multiline"></data-list-parents></div>                                
                                </b-tab-item>
                            </b-tabs>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NewTopMenu from "./../../NewTopMenu";
import AddContent from './AddContent';
import DataList from './DataList';
import DataListParents from './DataListParents';
import axios from "axios";
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "ManageNotificationsHome",
    components: {
        NewTopMenu,
        Loading,
        AddContent,
        DataList,
        DataListParents
    },
    data() {
        return {
            dataList: [],
            dataListParents: [],
            isLoading: false,
            addContent: false,
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
        console.log("before mount hoho");
        this.getData()
        this.getData2()
    },
    methods: {
        addContentForm(){
            this.addContent = true;
        },
        closeAddContentForm(){
            this.addContent = false;
        },
        getData(){
            let self = this;
            self.isLoading = true;

            self.dataList = []

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/notifications/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
            })
            .then(response => {
                // JSON responses are automatically parsed.
                self.dataList = response.data
                self.isLoading = false
            })
            .catch(e => {
                console.log(e)
                self.isLoading = false
            })
        },
        getData2(){
            //get parents notifications data 
            let self = this;
            self.isLoading = true;

            self.dataListParents = []

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/behaviors/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                dataType: 3
            })
            .then(response => {
                self.dataListParents = response.data
                self.isLoading = false

                console.log("!27 self.dataListParents")
                console.log(self.dataListParents)
            })
            .catch(e => {
                console.log(e)
                self.isLoading = false
            })
        },
        goManageClasses(){
            this.$router.push({
                name: "ManageClassesHome"
            });
        },
        goManageTeachers(){
            this.$router.push({
                name: "ManageTeachersHome"
            });
        },
        goManageBehaviors(){
            this.$router.push({
                name: "ManageBehaviorsHome"
            });
        },   
        goManageGroups(){
            this.$router.push({
                name: "ManageGroupsHome"
            });
        },
        goManageBadges(){
            this.$router.push({
                name: "ManageBadgesHome"
            });
        }
    },
    created() {
    },
    mounted(){
    },
};
</script>

<style scoped>
.container{
    padding: 10px;
}
.box{
    border: 1px solid #ccc;
    width: 40% !important;
    margin: 4px;
    padding: 0px !important;
}
.active{
    border: 1px solid rgb(6, 50, 247);
}
</style>



// WEBPACK FOOTER //
// src/components/Manage/Notifications/Home.vue